import React, { useState, useEffect } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'
import AdminNavbarAlternative from 'components/argon/Navbars/AdminNavbarAlternative.js'
import Sidebar from 'components/argon/Sidebar/Sidebar.js'
import Box from '@material-ui/core/Box'
import PaymentIcon from '@material-ui/icons/Payment'
import StoreIcon from '@material-ui/icons/Store'
import VisibilityIcon from '@material-ui/icons/Visibility'
import SettingsIcon from '@material-ui/icons/Settings'
import VerifiedIcon from '@material-ui/icons/CheckCircle'
import { makeStyles } from '@material-ui/core/styles'
import componentStyles from 'assets/theme/layouts/admin.js'
import eeLogo from 'resources/images/ee-logo.png'

import Profile from 'scenes/provider/Profile'
import Verification from 'scenes/provider/Verification'
import Billing from 'scenes/provider/Billing'
import TermsConditions from 'scenes/provider/TermsConditions'

const useStyles = makeStyles(componentStyles)

const Main = (props) => {
    const classes = useStyles()
    const location = useLocation()
    const [sidebarOpenResponsive, setSidebarOpenResponsive] = useState(false)

    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.scrollingElement.scrollTop = 0
        // mainContent.current.scrollTop = 0
    }, [location])

    const isSolar = props.isSolarProvider !== false
    // Any provider offering at least one product gets the editable profile.
    const enabledProducts = props.enabledProducts || []
    const hasProfile = isSolar || enabledProducts.length > 0

    var routes = []

    if (hasProfile) {
        routes.push(
            {
                path: '/profile',
                name: 'Profile',
                icon: StoreIcon,
                iconColor: 'Success',
                component: Profile,
            },
            {
                path: '/verification',
                name: 'Verification',
                icon: VerifiedIcon,
                iconColor: 'Success',
                component: Verification
            }
        )
    }

    // Billing: always available to providers with a profile once set up; for
    // providers without a profile, always show billing.
    if (!hasProfile || (props.companyDetails.billingEnabled && props.details.billingEnabled === 'Yes') || props.skipped || (props.details.counties && props.details.counties.length > 0) || (props.details.eircodeAreas && props.details.eircodeAreas.length > 0)) {
        routes.push({
            path: '/billing',
            name: 'Billing',
            icon: PaymentIcon,
            iconColor: 'Success',
            component: Billing
        })
    }

    const defaultRoute = hasProfile ? '/profile' : '/billing'

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return getRoutes(prop.views)
            } 
            else {
                return (
                    <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                    />
                )
            }
        });
    };

    return (
        <>
            <Box display='flex'>
                <Sidebar
                    routes={routes}
                    openResponsive={sidebarOpenResponsive}
                    closeSidebarResponsive={() => setSidebarOpenResponsive(false)}
                    accountType='provider'
                    logo={{
                        innerLink: '/',
                        imgSrc: eeLogo,
                        imgAlt: '...',
                        className: 'sidebar-logo',
                    }}
                />
                <Box position='relative' flex='1' className={classes.mainContent}>
                    <AdminNavbarAlternative
                        openSidebarResponsive={() => setSidebarOpenResponsive(true)}
                        email={props.details.primaryPerson.email}
                        companyName={props.details.name}
                        companyDetails={props.companyDetails}
                    />
                    
                    <Switch>
                        {getRoutes(routes)}
                        <Route path='/terms-conditions' component={TermsConditions} />
                        <Redirect from='*' to={defaultRoute} />
                    </Switch>
                </Box>
            </Box>
        </>
    )
}

export default Main